import React from 'react';
import { Box, Grid, Typography, Divider } from '@mui/material';

const HeaderItem = ({ xs, label }) => (
  <Grid item xs={xs} align="center">
    <Typography sx={{ fontWeight: 'bold', color: '#333', fontSize: '0.85rem', lineHeight: '32px' }}>
      {label}
    </Typography>
  </Grid>
);

const DataItem = ({ xs, value, color = 'text.primary' }) => (
  <Grid item xs={xs} align="center">
    <Typography 
      sx={{ 
        fontSize: '0.9rem', 
        color: color, 
        lineHeight: '32px', 
        whiteSpace: 'nowrap', 
        padding: '0 4px',
        overflow: 'hidden', 
        textOverflow: 'ellipsis' 
      }}
    >
      {value || '-'}
    </Typography>
  </Grid>
);

const ApprovalTaxSummary = ({ info, taxbill }) => {
  const getStatus = (yn) => {
    if (yn === 'S') return { text: '진행중', color: '#1976d2' };
    if (yn === 'Y') return { text: '완료', color: '#2e7d32' };
    if (yn === 'N') return { text: '거부', color: '#d32f2f' };
    return { text: '-', color: 'text.secondary' };
  };

  const status = getStatus(info?.docuYn);

  return (
    <Box sx={{ width: '100%' }}>
      <Grid 
        container 
        sx={{ 
          height: '32px', 
          bgcolor: '#f1f3f5', 
          borderBottom: '1px solid #dee2e6',
          alignItems: 'center'
        }}
      >
        <HeaderItem xs={1.5} label="결재 문서번호" />
        <HeaderItem xs={2} label="계산서 발행일자" />
        <HeaderItem xs={1} label="결재타입" />
        <HeaderItem xs={2.5} label="작성일자" />
        <HeaderItem xs={1} label="작성자" />
        <HeaderItem xs={1.5} label="결재상태" />
        <HeaderItem xs={2.5} label="최종승인일자" />
      </Grid>
      <Grid 
        container 
        sx={{ 
          height: '32px', 
          alignItems: 'center', 
          bgcolor: '#fff' 
        }}
      >
        <DataItem xs={1.5} value={info?.docuNo} />
        <DataItem xs={2} value={taxbill?.reqCompDt} />
        <DataItem xs={1} value={info?.docyTyp} />
        <DataItem xs={2.5} value={info?.crtDt} />
        <DataItem xs={1} value={info?.crtNm} />
        <DataItem xs={1.5} value={status.text} color={status.color} />
        <DataItem xs={2.5} value={info?.docuDt} />
      </Grid>
      <Divider />
    </Box>
  );
};

export default ApprovalTaxSummary;
